import { CalendarMonth, Email, Notes, Phone, Person } from '@mui/icons-material'
import EmailModal from './customer/task/EmailModal'
import EventModal from './customer/task/EventModal'
import GenericTaskModal from './customer/task/GenericTaskModal'
import PhoneModal from './customer/task/PhoneModal'
import MeetModal from './customer/task/MeetModal'

export const EMAIL_REGEX =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export const PASSWORD_REGEX =
  /[^a-z^A-Z^0-9\^\~\!\@\#\$\%\^\*\-\_\=\+\[\{\]\}\/\;\:\,\.\?]+/g

export const EXP_REGEX = /^(0[1-9]|1[0-2])\/([0-9]{2})$/

export const MAX_ALLOWED_STAGES = 7
export const MAX_ALLOWED_PIPELINES = 5
export const PIPELINE_NAME_MAX_LENGTH = 25

export const MAX_ALLOWED_CUSTOM_FIELDS = 20
export const MAX_ALLOWED_CUSTOM_FIELD_OPTIONS = 20

export const STAGE_COLORS = [
  'orange',
  'blue',
  'green',
  'yellow',
  'purple',
  'red',
  'gray',
]

export const TASK_STATUS_TYPES = {
  NOT_STARTED: 1,
  DONE: 3,
}

export const TASK_TYPES = {
  PHONE_CALL: 1,
  EMAIL: 2,
  SCHEDULE_EVENT: 3,
  ATTEND_EVENT: 4,
  GENERAL: 5,
  MEET: 6,
}

export const TASK_TYPE_ICON_MAP = {
  [TASK_TYPES.PHONE_CALL]: Phone,
  [TASK_TYPES.EMAIL]: Email,
  [TASK_TYPES.ATTEND_EVENT]: CalendarMonth,
  [TASK_TYPES.GENERAL]: Notes,
  [TASK_TYPES.MEET]: Person,
}

export const TASK_TYPE_DROPDOWN_MAP = {
  [TASK_TYPES.PHONE_CALL]: 'phoneCallOutcomes',
  [TASK_TYPES.EMAIL]: 'emailOutcomes',
  [TASK_TYPES.ATTEND_EVENT]: 'eventOutcomes',
  [TASK_TYPES.MEET]: 'metOutcomes',
}

export const TASK_TYPE_MODAL_MAP = {
  [TASK_TYPES.PHONE_CALL]: PhoneModal,
  [TASK_TYPES.EMAIL]: EmailModal,
  [TASK_TYPES.SCHEDULE_EVENT]: EventModal,
  [TASK_TYPES.ATTEND_EVENT]: EventModal,
  [TASK_TYPES.GENERAL]: GenericTaskModal,
  [TASK_TYPES.MEET]: MeetModal,
}

export const TASK_TYPE_MODAL_DISPLAY_NAMES = {
  [TASK_TYPES.PHONE_CALL]: 'Phone call',
  [TASK_TYPES.EMAIL]: 'Email',
  [TASK_TYPES.SCHEDULE_EVENT]: 'Event',
  [TASK_TYPES.MEET]: 'Meet in person',
  [TASK_TYPES.GENERAL]: 'General',
}

export const ACCOUNT_PROVIDERS = [
  {
    id: 1,
    name: 'Google',
    calendarUrl: 'https://calendar.google.com/calendar',
    getEmailUrl: (address) =>
      `https://mail.google.com/mail/u/0/?tf=cm&to=${address}`,
  },
  {
    id: 2,
    name: 'Outlook',
  },
]

export const STRATEGY_PLAN_SECTIONS = {
  primaryObjective: 'Primary Objective',
  strategy: 'Strategy to Achieve Objective',
  tactics: 'Tactics',
  marketingEfforts: 'Marketing Efforts',
  peopleNeeded: 'People Needed',
  education: 'Education',
}

export const LIONS_CLUB_CAP = 1000

export const MOTIVATIONAL_QUOTE_COLOR_OPTIONS = [
  'black',
  'blue',
  'red',
  'orange',
  'pink',
  'green',
  'yellow',
  'purple',
]

export const DEFAULT_PRICE = 49.0
export const LIONS_CLUB_PRICE = 49.0

export const SUPPORT_NUMBER = '801-870-9404'

export const OUTCOMES = ['Successful', 'Unsuccessful', 'Neutral']
